module.exports = __webpack_public_path__ + "static/media/ball_2_1.95395e23.mp3";